<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('menu.setup_initial')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md2 sm6 xs12">
                <va-select
                  :label="$t('forms.selects.locality')"
                  v-model="setupParams.locality"
                  keyBy="id"
                  textBy="name"
                  :options="listLocalities"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('forms.selects.palletizationTypes')"
                  v-model="setupParams.palletizationType"
                  keyBy="id"
                  textBy="name"
                  :options="palletizationTypes"
                />
              </div>

              <div class="flex md2 sm6 xs12">
                <va-select
                  :label="$t('forms.selects.sortTypes')"
                  v-model="setupParams.sortType"
                  keyBy="id"
                  textBy="name"
                  :options="sortTypes"
                />
              </div>

              <div class="flex md2 sm3 xs4" v-if="setupParams.blind_conference == true">
                <va-input
                  type="number"
                  v-model="setupParams.quantity_attempts"
                  :label="$t('forms.inputs.quantityAttempts')"
                  removable
                >
                </va-input>
              </div>

              <div class="flex md2 sm3 xs4" v-if="setupParams.blind_conference == true">
                <va-input
                  type="number"
                  v-model="setupParams.palletizing_complexity_check"
                  :label="$t('forms.inputs.ComplexityCheck')"
                  removable
                >
                </va-input>
              </div>

            </div>

            <div class="row">
              <div class="flex md2 sm1 xs4">
                <va-toggle
                  v-model="setupParams.blind_conference"
                  :label="$t('forms.inputs.blindConference')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <div class="flex md2 sm6 xs12" v-if="setupParams.blind_conference === true">
                <va-select
                  :label="$t('forms.selects.blindConferenceTypes')"
                  v-model="setupParams.blindConferenceType"
                  keyBy="id"
                  textBy="name"
                  :options="blindConferenceTypes"
                />
              </div>

              <div class="flex md2 sm1 xs4">
                <va-toggle
                  v-model="setupParams.ranking"
                  :label="$t('forms.inputs.ranking')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <div class="flex md2 sm2 xs4">
                <va-toggle
                  v-model="setupParams.bar_code"
                  :label="$t('forms.inputs.barCode')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <div class="flex md2 sm2 xs4">
                <va-toggle
                  v-model="setupParams.sap_integration"
                  :label="$t('forms.inputs.sapIntegration')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <div class="flex md2 sm2 xs4">
                <va-toggle
                  v-model="setupParams.check_for_divergences"
                  :label="$t('tables.setup.check_for_divergences')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <div class="flex md2 sm1 xs4">
                <va-toggle
                  v-model="setupParams.container_distribution"
                  :label="$t('tables.setup.container_distribution')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <div class="flex md2 sm2 xs4">
                <va-toggle
                  v-model="setupParams.locker_availability"
                  :label="$t('tables.setup.locker_availability')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <div class="flex md2 sm2 xs4">
                <va-toggle
                  v-model="setupParams.automatic_palletization"
                  :label="$t('tables.setup.automatic_palletization')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <!-- <div class="flex md2 sm2 xs4">
                <va-toggle
                  v-model="setupParams.ia_palletization"
                  :label="$t('tables.setup.ia_palletization')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <div class="flex md2 sm2 xs4">
                <va-toggle
                  v-model="setupParams.ia_sort"
                  :label="$t('tables.setup.ia_sort')"
                  :color="$themes.secondary"
                  small
                />
              </div> -->

              <div class="flex md2 sm2 xs4">
                <va-toggle
                  v-model="setupParams.separation_by_client"
                  :label="$t('tables.setup.separation_by_client')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <div class="flex md2 sm3 xs4" v-if="setupParams.separation_by_client === true">
                <va-input
                  v-model="setupParams.minimal_cubage_by_client"
                  :label="$t('forms.inputs.minimal_cubage_by_client')"
                >
                </va-input>
              </div>

            </div>
            <div class="row">
              <div class="flex md2 sm6 xs12">
                <va-button
                  v-if="setupParams.setupId == ''"
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="create(setupParams)"
                >
                  {{ $t('menu.save') }}
                </va-button>
                <va-button
                  v-else
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="update(setupParams)"
                >
                  {{ $t('menu.update') }}
                </va-button>
              </div>
              <div class="flex md2 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                    :to="{ name: 'setup-initial', params: {
                      current_page: this.$route.params.current_page,
                      searchName: this.$route.params.searchName,
                      perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import SetupAPI from '@/services/SetupAPI'
import LocalityAPI from '@/services/LocalityAPI'
import PalletizationTypesAPI from '../../../services/PalletizationTypesAPI'
import SortTypesAPI from '../../../services/SortTypesAPI'

export default {
  name: 'form-setup',
  components: {},
  data () {
    return {
      setupParams: {
        setupId: '',
        blind_conference: false,
        bar_code: '',
        sap_integration: '',
        name: '',
        locality: {
          id: '',
          name: '',
        },
        quantity_attempts: 0,
        palletizing_complexity_check: 0,
        ranking: false,
        check_for_divergences: '',
        container_distribution: '',
        locker_availability: '',
        ia_palletization: '',
        ia_sort: '',
        cdn: '',
        palletizationType: {
          id: '',
          name: '',
        },
        sortType: {
          id: '',
          name: '',
        },
        separation_by_client: '',
        minimal_cubage_by_client: '',
        automatic_palletization: '',
        blindConferenceType: {
          id: '',
          name: '',
        },
      },
      listLocalities: [],
      palletizationTypes: [],
      sortTypes: [],
      blindConferenceTypes: [],
    }
  },
  mounted () {
    this.readItems()
  },
  methods: {
    async readItems () {
      await LocalityAPI.getAllLocalitiesWithoutLimit().then(response => {
        this.listLocalities = response.data.localities
      })

      await PalletizationTypesAPI.getAllPalletizationTypes().then(response => {
        this.palletizationTypes = response.data.palletization_types
      })

      await SortTypesAPI.getAllSortTypes().then(response => {
        this.sortTypes = response.data.sort_types
      })

      await SetupAPI.getAllBlindConferenceTypes().then(response => {
        this.blindConferenceTypes = response.data.blind_conference_types
      })

      if (this.$route.params.id !== undefined) {
        await SetupAPI.getSetupById(this.$route.params.id).then(response => {
          let res = response.data.setup

          this.setupParams.setupId = res.id
          this.setupParams.blind_conference = res.blind_conference
          this.setupParams.bar_code = res.bar_code
          this.setupParams.sap_integration = res.sap_integration
          this.setupParams.name = res.name
          this.setupParams.locality = res.locality
          this.setupParams.quantity_attempts = res.quantity_attempts
          this.setupParams.ranking = res.ranking
          this.setupParams.check_for_divergences = res.check_for_divergences
          this.setupParams.container_distribution = res.container_distribution
          this.setupParams.locker_availability = res.locker_availability
          this.setupParams.ia_palletization = res.ia_palletization
          this.setupParams.ia_sort = res.ia_palletization
          this.setupParams.palletizationType = res.palletization_type
          this.setupParams.sortType = res.sort_type
          this.setupParams.palletizing_complexity_check = res.palletizing_complexity_check
          this.setupParams.separation_by_client = res.separation_by_client
          this.setupParams.minimal_cubage_by_client = res.minimal_cubage_by_client
          this.setupParams.automatic_palletization = res.automatic_palletization
          this.setupParams.blindConferenceType = res.blind_conference_type
        })
      }
    },
    create (setupParams) {
      SetupAPI.createSetup(setupParams).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        this.$router.push('/admin/tables/setup-initial')
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    update (setupParams) {
      SetupAPI.updateSetup(setupParams).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        this.$router.push('/admin/tables/setup-initial')
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },
  },
}
</script>
